/* unplugin-vue-components disabled */import { render } from "./News.vue?vue&type=template&id=eb2898ea&scoped=true"
import script from "./News.vue?vue&type=script&lang=js"
export * from "./News.vue?vue&type=script&lang=js"

import "./News.vue?vue&type=style&index=0&id=eb2898ea&lang=scss&scoped=true"
import "./News.vue?vue&type=style&index=1&id=eb2898ea&scoped=true&lang=scss"

import exportComponent from "/root/.jenkins/workspace/高保障-门户南京邮电-前端页面-saas/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-eb2898ea"]])

export default __exports__